import { useCallback, useState } from "react";

const MINIMUM_LOADING_DURATION = 800;

export function useLoading() {
  const [loading, setLoading] = useState(false);

  const withLoading = useCallback(
    async <T>(asyncFunction: () => Promise<T>): Promise<T> => {
      setLoading(true);

      const startTime = Date.now();

      try {
        return await asyncFunction();
      } finally {
        const elapsedTime = Date.now() - startTime;
        const remainingTime = Math.max(
          MINIMUM_LOADING_DURATION - elapsedTime,
          0,
        );

        if (remainingTime > 0) {
          await new Promise((resolve) => setTimeout(resolve, remainingTime));
        }

        setLoading(false);
      }
    },
    [],
  );

  return {
    loading,
    withLoading,
  };
}
